import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import React, { createContext, useState } from "react";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 999999,
    color: "#fff",
  },
}));

export const ModalLoadingContext = createContext({
  isOpen: false,
  showLoading: () => { },
  hideLoading: () => { },
});

function ModalLoadingProvider({ children }) {
  const classes = useStyles();

  const [isOpen, setOpen] = useState(false);
  const showLoading = () => {
    setOpen(true);
  };
  const hideLoading = () => {
    setOpen(false);
  };

  return (
    <ModalLoadingContext.Provider
      value={{
        isOpen,
        showLoading,
        hideLoading,
      }}
    >
      {children}
      <Backdrop className={classes.backdrop} open={isOpen} id="loading">
        <CircularProgress color="inherit" />
      </Backdrop>
    </ModalLoadingContext.Provider>
  );
}

export default ModalLoadingProvider;
